import { dark } from '@/scss/themes/dark'
import { light } from '@/scss/themes/light'
import { useI18n } from 'vue-i18n'
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { i18n } from '../locales/i18n'

export default createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            fa,
            mdi
        }
    },
    theme: {
        defaultTheme: 'dark',
        themes: {
            light,
            dark
        }
    },
    locale: {
        adapter: createVueI18nAdapter({ i18n, useI18n })
    }
})
